// @flow
import React from 'react';
import injectSheet from 'react-jss';
import Modal from '~/app/components/Modal';
import DeployMode from '~/deploy/components/DeployModeContainer';
import _ from 'shared/lib/gettext';
import { pagePublicPath as getDisplayPath } from '~/lib/pagePublicPath';
import { TONES, DARK } from '~/app/ui/tokens';

type Page = {
  title: string,
  path: string
}

type Props = {
  classes: Object,
  onDeploy: () => void,
  onCancel: () => void,
  nextVersion: string,
  pages: Array<Page>,
  selectedVersionIds: Array<string>
}

const DeployModal = (props: Props) => {
  const {
    classes: c, onDeploy, onCancel, nextVersion, pages, selectedVersionIds
  } = props;

  return (
    <Modal
      onClose={onCancel}
      modalStyle="simple"
      disableFooter
    >
      <div className={c.deployModalBody}>
        <h3 className={c.sectionTitle}>{_('REDEPLOY_SELECTED')}</h3>
        {
          pages.map(p => (
            <div key={p.path}>{`${p.title} - ${getDisplayPath(p.path)}`}</div>
          ))
        }
        <h3 className={c.sectionTitle}>{_('DEPLOY_VERSION')}</h3>
        <DeployMode
          deployMode="REDEPLOY_SELECTED"
          cancelBtnEnabled
          version={nextVersion}
          selectedVersionIds={selectedVersionIds}
          onCancel={onCancel}
          onSuccessDeploy={onDeploy}
        />
      </div>
    </Modal>
  );
};

const styles = {
  deployModalBody: {
    width: '100%',
    padding: '20px 30px'
  },
  deployAllNote: {
    fontSize: '13px'
  },
  scheduledDeploymentNote: {
    fontSize: '13px',
    marginTop: '5px',
    color: 'hsl(0, 34%, 48%)',
    [DARK]: { color: TONES.red.fg }
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: '700'
  }
};

export default injectSheet(styles)(DeployModal);
